import { useLocation, useNavigate, useParams } from 'react-router-dom'
import useSending from './hooks/useSending'
import Materials from './steps/Materials'
import FirstView from './views/FirstView'
import HaveCode from './views/HaveCode'
import QrScanner from 'pages/QrScanner'
import TopBar from 'components/Topbar'
import useForm from './hooks/useForm'
import './index.scss'

const AddProfile: React.FC = () => {
  const [form, updateFormValue, updateForm] = useForm()
  const { isSending, handleSubmit } = useSending(form)
  const { pathname, search, state } = useLocation()
  const params = useParams()
  const view = state?.view

  const navigate = useNavigate()
  const setView = (_view: string) => {
    navigate(`${pathname}${search}`, { state: { ...state, view: _view } })
  }

  return (
    <div className="addProfile">
      <TopBar
        theme='dark'
        title='Dodawanie wirtualnego profilu'
        isSticky={false}
      />

      {(() => {
        switch (view) {
          case 'haveCode':
            return <HaveCode
              setView={setView}
              updateForm={updateForm}
            />
          case 'qrScanner':
            return <QrScanner
              setQrData={({ id }) => {
                updateFormValue('qrId', id)
                setView(state?.nextPage || 'addWithQrView')
              }}
            />
          case 'addWithQrView':
            return <Materials
              form={form}
              inStep={false}
              isSending={isSending}
              updateFormValue={updateFormValue}
              handleSubmit={() => {
                handleSubmit(false, form.updateProfile)
              }} />
          default:
            return <FirstView
              form={form}
              setView={setView}
              isSending={isSending}
              handleSubmit={handleSubmit}
              updateFormValue={updateFormValue}
              withoutOptions={!!(params['id'] || form.qrId)}
            />
        }
      })()}
    </div>
  )
}

export default AddProfile